import * as React from 'react'
function SvgCat(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M32.766 4.152a2 2 0 00-2.18.434L25.172 10H14.828L9.414 4.586A2 2 0 006 6v16c0 7.72 6.281 14 14 14s14-6.28 14-14V6c0-.809-.486-1.538-1.234-1.848zM14 22a2 2 0 110-4 2 2 0 010 4zm12 0a2 2 0 110-4 2 2 0 010 4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgCat
